import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import itLocale from '@fullcalendar/core/locales/it';
import interactionPlugin from '@fullcalendar/interaction';
import resourceTimelinePlugin from '@fullcalendar/resource-timeline';

window.fullCalendar = function () {
  if ($('#calendar').length > 0) {
    var view
    if ($('#calendar_option').val() != '' && $('#calendar_option').val() != undefined) {
      console.log(' 111 - - - calendar_option - - -  1111 ')
      $('#filter_option').parent().removeClass("d-none");
      var calendar_option = $('#calendar_option').val()
      var filter_option = $('#filter_option').val()
      if (filter_option == undefined) {
        var filter_option = ''
      }
      if ($('#customer_operations').length > 0) {
        console.log('---- customer_operations --- ')
        var update_operation = "/customers/update_operation"
        if (calendar_option == 'activity') {
        console.log('---- customer_operations ACTIVITY --- ')
          console.log('1111111')
          var events = "/customers/" + $("#customer_id").val() + "/get_customer_events?filter_option=" + filter_option
          var resources = "/customers/" + $("#customer_id").val() + "/get_customer_resources?filter_option=" + filter_option
          var resource_name = 'Attività'
        } else if (calendar_option == 'operator') {
          console.log('22222222')
          var events = "/operators/get_operators_events?filter_option=" + filter_option
          var resources = "/operators/get_operators_resources?filter_option=" + filter_option
          var resource_name = 'Operatori'
        } else if (calendar_option == 'role_operator') {
          console.log('333333333')
          var events = "/operator_roles/get_operators_roles_events?filter_option=" + filter_option
          var resources = "/operator_roles/get_operators_roles_resources?filter_option=" + filter_option
          var resource_name = 'Ruolo operatori'
        }
      } else {
        console.log('---- customer_operations ELSE --- ')
        if (calendar_option == 'activity') {
          console.log('1111111')
          var events = "/activities/get_activities_events?filter_option=" + filter_option
          var resources = "/activities/get_activities_resources?filter_option=" + filter_option
          var update_operation = "/activities/update_operation"
          var resource_name = 'Attività'
        } else if (calendar_option == 'operator') {
          console.log('22222222')
          var events = "/operators/get_operators_events?filter_option=" + filter_option
          var resources = "/operators/get_operators_resources?filter_option=" + filter_option
          var update_operation = "/operators/update_operation"
          var resource_name = 'Operatori'
        } else if (calendar_option == 'role_operator') {
          console.log('333333333')
          var events = "/operator_roles/get_operators_roles_events?filter_option=" + filter_option
          var resources = "/operator_roles/get_operators_roles_resources?filter_option=" + filter_option
          var resource_name = 'Ruolo operatori'
        }
      }
    } else {
      console.log(' 111 - - - calendar_option ELSE - - -  1111 ')
      $('#filter_option').parent().addClass("d-none")
      if ($('#event_activity_id').length > 0) {
        console.log('11111111')
        var events = "/customers/" + $('#customer_id').val() + "/activities/" + $('#event_activity_id').val() + "/get_activity_events"
        var resources = "/customers/" + $('#customer_id').val() + "/activities/" + $('#event_activity_id').val() + "/get_activity_resources"
        var update_operation = "/activities/update_operation"
        var resource_name = 'Fasi'
      } else  if ($('#customer_operations').length > 0) {
          console.log('22222222')
        var events = "/customers/" + $('#customer_id').val() + "/get_customer_events"
        var resources = "/customers/" + $('#customer_id').val() + "/get_customer_resources"
        var update_operation = "/customers/update_operation"
        var resource_name = 'Attività'
      } else  if ($('#activities_calendar').length > 0) {
        console.log('333333333')
        var events = "/activities/get_activities_events"
        var resources = "/activities/get_activities_resources"
        var update_operation = "/activities/update_operation"
        var resource_name = 'Attività'
      } else  if ($('#all_operators_calendar').length > 0) {
        console.log('44444444')
        var events = "/operators/get_operators_events"
        var resources = "/operators/get_operators_resources"
        var update_operation = "/operators/update_operation"
        var resource_name = 'Operatori'
      } else  if ($('#operator_calendar').length > 0) {
        console.log('555555555')
        var events = "/operators/" + $('#operator_calendar').val() + "/get_operators_events"
        var update_operation = "/operators/" + $('#operator_calendar').val() + "/update_operation"
        var resource_name = 'Operatori'
      } else {
        console.log('66666666666')
        var events = "/customers/" + $('#customer_id').val() + "/get_operations"
        var update_operation = "/customers/" + $('#customer_id').val() + "/update_operation"
        var resource_name = 'Clienti'
      }
    }

    var currentUrl = document.location.href;
    if (currentUrl.indexOf("?view=") != -1) {
      // vuol dire che lo contiene
      var initialView = document.location.href.split("?view=")[1];
    } else {
      // var initialView = 'resourceTimelineWeek'
      var initialView = 'dayGridMonth'
    }

    console.log('initialView === ' + initialView)

    var calendarEl = document.getElementById('calendar');
    var calendar = new Calendar(calendarEl, {
      schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives',
      plugins: [ dayGridPlugin, interactionPlugin, resourceTimelinePlugin ],
      // plugins: [ dayGridPlugin, timeGridPlugin, interactionPlugin, resourceTimelinePlugin ],
      locale: itLocale,
      initialView: initialView,
      headerToolbar: {
        left: 'prevYear,prev,next,nextYear today',
        center: 'title',
        right: 'dayGridMonth,resourceTimelineWeek'
        // right: 'dayGridMonth,timeGridWeek,resourceTimelineWeek'
      },
      displayEventTime: false,
      height: 'auto',
      resourceOrder: 'order',
      resourceAreaWidth: "20%",
      nowIndicator: true,
      dragRevertDuration: 50,
      slotDuration: '24:00:00',
      slotLabelFormat: [
        { month: 'long', year: 'numeric' }, // top level of text
        { weekday: 'short' },
      ],
      editable: true,
      eventStartEditable: true,
      dragScroll: true,
      resources: resources,
      events: events,
      // sto modificando la durata di un evento
      resourceAreaColumns: [
        {
          field: 'resource_name',
          headerContent: resource_name
        },
      ],
      eventResize: function(resize) {
        $.ajax({
          type: 'PATCH',
          url: update_operation + "?dragged=" + true,
          data: {
            operation_id: resize.event["id"],
            view: resize.view["type"],
            new_end: resize.event.end,
            start: resize.event.start,
            days: resize.endDelta["days"]
          },
          dataType: 'json'
        });
      },
      eventClick : function(click) {
        window.location.replace("/customers/" + click.event["extendedProps"]["customer_id"] + "/activities/" + click.event["extendedProps"]["activity_id"] + "/operations")
      },
      // sto spostando un evento da un giorno ad un altro
      eventDrop: function(info) {
        var options = {'weekday': 'long', 'month': '2-digit', 'day': '2-digit'};
        var start = new Date(info.oldEvent["start"].toISOString()).toLocaleString('it-IT', options);
        var new_start = new Date(info.event["start"].toISOString()).toLocaleString('it-IT', options);
        var str = info.event.title + " è stato spostato dal " + start + " al " + new_start + ". ";
        if (!confirm(str + "Confermi?")) {
          info.revert();
        } else {
          $.ajax({
            type: 'PATCH',
            url: update_operation,
            data: {
              operation_id: info.oldEvent["id"],
              start: info.event["start"],
              end: info.event["end"]
            },
            dataType: 'json'
          });
        }
      },
    });
    calendar.render();


    calendar.on('datesSet', function(view){
      var view = view["view"]["type"];
      var currentUrl = document.location.href;
      if (currentUrl.indexOf("?view=") != -1) {
        // vuol dire che lo contiene
        var currentUrl = document.location.href.split("?view=")[0];
        var newUrl = currentUrl + "?view=" + view;
      } else {
        var newUrl = document.location.href + "?view=" + view;
      }
      window.history.pushState(newUrl, newUrl, newUrl);
      $(".operation_btn").each(function(el, i) {
        var href = $(this).attr("href")
        if (href.indexOf("?") != -1) {
          if (href.indexOf("?view=") != -1) {
            var href = href.split("?view=")[0];
            var newHref = href + "?view=" + view;
          } else if (href.indexOf("&view=") != -1) {
            var href = href.split("&view=")[0];
            var newHref = href + "&view=" + view;
          } else {
            var newHref = href + "&view=" + view;
          }
        } else {
          if (href.indexOf("?view=") != -1) {
            var href = href.split("?view=")[0];
            var newHref = href + "?view=" + view;
          } else {
            var newHref = href + "?view=" + view;
          }
        }
        $(this).attr("href", newHref)
      })
      var initialView = view
      console.log( ' initialView ==== ' + initialView)

      if (view == 'resourceTimelineWeek') {
        console.log('---- resourceTimelineWeek --- ')
        if ($('#event_activity_id').length > 0) {
          var events = "/customers/" + $('#customer_id').val() + "/activities/" + $('#event_activity_id').val() + "/get_activity_events"
          console.log('1111111')
          var resources = "/customers/" + $('#customer_id').val() + "/activities/" + $('#event_activity_id').val() + "/get_activity_resources"
        } else if ($('#activities_calendar').length > 0) {
          console.log('22222222')
          var events = "/activities/get_activities_events"
          var resources = "/activities/get_activities_resources"
        } else  if ($('#customer_operations').length > 0) {
          console.log('333333333333333')
          var events = "/customers/" + $('#customer_id').val() + "/get_customer_events"
          var resources = "/customers/" + $('#customer_id').val() + "/get_customer_resources"
        } else  if ($('#all_operators_calendar').length > 0) {
          console.log('44444444')
          var events = "/operators/get_operators_events"
          var resources = "/operators/get_operators_resources"
        } else  if ($('#all_operators_roles_calendar').length > 0) {
          console.log('555555555555')
          var events = "/operator_roles/get_operators_roles_events"
          var resources = "/operator_roles/get_operators_roles_resources"
        }
        var calendar = new Calendar(calendarEl, {
          plugins: [ dayGridPlugin, interactionPlugin, resourceTimelinePlugin ],
          // plugins: [ dayGridPlugin, timeGridPlugin, interactionPlugin, resourceTimelinePlugin ],
          initialView: initialView,
          events: events + "?view=" + view,
          resources: resources + "?view=" + view,
        });
      } else if (view == "dayGridMonth" || view == "timeGridWeek") {
        if ($('#event_activity_id').length > 0) {
          var events = "/customers/" + $('#customer_id').val() + "/activities/" + $('#event_activity_id').val() + "/get_activity_events"
          console.log('1111111')
        } else if ($('#activities_calendar').length > 0) {
          console.log('22222222')
          var events = "/activities/get_activities_events"
        } else  if ($('#all_operators_calendar').length > 0) {
          console.log('333333333333333')
          var events = "/operators/get_operators_events"
        } else  if ($('#customer_operations').length > 0) {
          console.log('44444444')
          var events = "/customers/" + $('#customer_id').val() + "/get_customer_events"
        } else  if ($('#all_operators_roles_calendar').length > 0) {
          console.log('555555555555')
          var events = "/operator_roles/get_operators_roles_events"
        }
        var calendar = new Calendar(calendarEl, {
          plugins: [ dayGridPlugin, interactionPlugin, resourceTimelinePlugin ],
          // plugins: [ dayGridPlugin, timeGridPlugin, interactionPlugin, resourceTimelinePlugin ],
          initialView: initialView,
          events: events + "?view=" + view,
        });
      }
    });
  }
}
